import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FabricanteAppRoutingModule } from "./fabricante.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        FabricanteAppRoutingModule
    ]
})
export class FabricanteAppModule { }
